import { Box, IconButton, Icon } from "@mui/material";
import MDTypography from "theme/components/MDTypography";

function PhotoCaptureBox({ image, onOpenCamera, onClear }) {
  return (
    <Box
      sx={{
        border: "2px dashed #d2d6da",
        borderRadius: "12px",
        height: 220,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#f8f9fa",
      }}
    >
      {!image && (
        <Box textAlign="center">
          <IconButton
            color="primary"
            onClick={onOpenCamera}
            sx={{
              width: 64,
              height: 64,
              backgroundColor: "#e3f2fd",
            }}
          >
            <Icon fontSize="large">photo_camera</Icon>
          </IconButton>

          <MDTypography variant="caption" mt={1} display="block">
            Tap to take photo
          </MDTypography>
        </Box>
      )}

      {image && (
        <>
          <img
            src={image}
            alt="captured"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />

          <IconButton
            onClick={onClear}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "white",
              border: "1px solid rgba(0,0,0,0.2)",
              boxShadow: 3,
              "&:hover": {
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            <Icon color="error">close</Icon>
          </IconButton>
        </>
      )}
    </Box>
  );
}

export default PhotoCaptureBox;
